import { defineMessages } from "@/i18n";
import en from "./en";

export const agentActivityToolMessages = defineMessages(
  "agent-activity-tool",
  en,
);
